export const homeworkColors = {
  1: '',
  2: 'yellow-line',
  3: 'red-line',
  4: 'green-line'
};
